import React from 'react';
import { Toolbar as MuiToolbar } from '@material-ui/core';
import { FixedBox, FixedBoxProps } from '../FixedBox';
import { SecondaryToolbar } from '../SecondaryToolbar';

interface ToolbarProps extends Pick<FixedBoxProps, 'isBottom' | 'disableDrawerOffset'> {
    minHeight?: string;
}

const Toolbar: React.FC<ToolbarProps> = ({ children, isBottom, disableDrawerOffset, minHeight }) => {
    return (
        <>
            <MuiToolbar style={{ minHeight }} />
            <FixedBox isBottom={isBottom} disableDrawerOffset={disableDrawerOffset}>
                <SecondaryToolbar>
                    {children}
                </SecondaryToolbar>
            </FixedBox>
        </>
    );
};

export default Toolbar;
